<template></template>

<script>
import items from "rfuncs/functions/items"

import deserialize_filelist from "../files/make/deserialize_filelist"
import new_file_from_virtualfile from "../files/make/new_file_from_virtualfile"

export default {
  props: ["filelist"],
  computed: {
    filenames() {
      return items(deserialize_filelist(this.filelist)).map(([path, file]) =>
        new_file_from_virtualfile({ path, file })
      )
    },
  },
}
</script>
